import { Badge } from '@/components/ui/Badge';
import {
  QUOTE_STATUS_LABELS, ORDER_STATUS_LABELS,
  type QuoteStatus, type OrderStatus,
} from '@/types/sales';

const QUOTE_TONES: Record<QuoteStatus, 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'brass'> = {
  draft:     'neutral',
  sent:      'info',
  accepted:  'success',
  rejected:  'danger',
  expired:   'warning',
  converted: 'brass',
};

const ORDER_TONES: Record<OrderStatus, 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'brass'> = {
  received:      'info',
  engineered:    'info',
  scheduled:     'brass',
  in_production: 'warning',
  qc:            'warning',
  shipped:       'success',
  delivered:     'success',
  on_hold:       'neutral',
  cancelled:     'danger',
};

export function QuoteStatusBadge({ status }: { status: QuoteStatus }) {
  return <Badge tone={QUOTE_TONES[status]}>{QUOTE_STATUS_LABELS[status]}</Badge>;
}

export function OrderStatusBadge({ status }: { status: OrderStatus }) {
  return <Badge tone={ORDER_TONES[status]}>{ORDER_STATUS_LABELS[status]}</Badge>;
}
